import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  BulkDeleteButton,
  usePermissions,
} from "react-admin";
import { Box, Typography } from "@mui/material";

const UserGuideAssignmentList = (props) => {
  const { permissions = [] } = usePermissions();

  return (
    <List title="User Guide Assignments" {...props}>
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          UserGuide Assignments
        </Typography>
      </Box>

      <Datagrid
        bulkActionButtons={
          permissions.includes("user-guides.delete") ||
          permissions.includes("user-guides.*") ||
          permissions.includes("*")
            ? <BulkDeleteButton />
            : false
        }
      >
        <TextField source="id" />


          <TextField source="user_email" />
        

         <TextField source="title" />
        
        <TextField source="assigned_by" />
        <TextField source="assigned_at" />
      </Datagrid>
    </List>
  );
};

export default UserGuideAssignmentList;